import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

function formatCurrency(value) {
  return currencyFormatter.format(Number(value || 0));
}

export function dailyAverageDeposit(day) {
  const loadCount = Number(day?.loadCount || 0);
  return loadCount > 0 ? Number(day?.totalLoad || 0) / loadCount : 0;
}

export function dailyAverageNetDeposit(day) {
  const loadCount = Number(day?.loadCount || 0);
  return loadCount > 0 ? Number(day?.netLoad || 0) / loadCount : 0;
}

function Row({ label, value, color }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        {color && (
          <Box
            sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: color }}
          />
        )}
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {value}
      </Typography>
    </Box>
  );
}

export default function NetLoadTooltipContent({
  dataIndex,
  axisValue,
  days = [],
  color,
  bucketUnit,
}) {
  if (dataIndex === null || dataIndex === undefined) return null;
  const day = days[dataIndex];
  if (!day) return null;
  const loadCount = Number(day.loadCount || 0);

  return (
    <Paper
      elevation={3}
      data-testid="net-load-tooltip"
      sx={{ px: 1.5, py: 1, minWidth: 190 }}
    >
      <Typography variant="caption" sx={{ fontWeight: 700 }} component="div">
        {bucketUnit === "month"
          ? day.date.slice(0, 7)
          : bucketUnit === "day" ? day.date : axisValue ?? day.date}
      </Typography>
      <Row label="Net load" value={formatCurrency(day.netLoad)} color={color} />
      <Row label="Total load" value={formatCurrency(day.totalLoad)} />
      <Row label="Loads" value={loadCount} />
      <Row
        label="Avg deposit (loads)"
        value={loadCount > 0 ? formatCurrency(dailyAverageDeposit(day)) : "—"}
      />
      <Row
        label="Avg net deposit"
        value={
          loadCount > 0 ? formatCurrency(dailyAverageNetDeposit(day)) : "—"
        }
      />
    </Paper>
  );
}
